export const TOOLTIP_SHOW_DELAY = 500; // ms; matches native browser tooltip delay
